import { Text, View } from "@react-pdf/renderer";
import { formatToTwoDecimal } from "../../../../utils/numberFormatter";
import {
  Payable_Commission,
  isEnabled,
} from "../../../../constants/featureSettings";

// PO commissions block for PayablePDF2 (info only, not part of Payable Amount).
// Sits in the left totals card, styled like the Total Qty rows above it.
const CommissionPDFSection = ({ commissions = [], currencySymbol, styles }) => {
  if (!isEnabled(Payable_Commission) || commissions.length === 0) return null;

  const total = commissions.reduce((sum, c) => sum + (Number(c.amount) || 0), 0);

  const Row = ({ label, amount, bold }) => (
    <View style={styles.summaryColumn}>
      <Text style={[styles.label, bold && { fontWeight: "bold" }]}>
        {label}:
      </Text>
      <Text style={[styles.summaryValue, bold && { fontWeight: "bold" }]}>
        <Text style={styles.currencySymbol}>{currencySymbol} </Text>
        {formatToTwoDecimal(amount)}
      </Text>
    </View>
  );

  return (
    <View style={{ marginTop: 8, gap: 2 }}>
      <Text style={[styles.label, { fontSize: 7 }]}>
        Commission (not included in Payable Amount)
      </Text>
      {commissions.map((c, index) => (
        <Row
          key={c.id}
          label={c.commission_name || `Commission ${index + 1}`}
          amount={c.amount}
        />
      ))}
      {commissions.length > 1 && (
        <Row label="Total Commission" amount={total} bold />
      )}
    </View>
  );
};

export default CommissionPDFSection;
